import React from 'react';
import { reduxForm } from 'redux-form';
import StepperData from './stepper_data';
import {validate1, validate2, validate3} from './validate';

function Stepper1(props){
  return <StepperData {...props}/>;
} 
Stepper1 = reduxForm({ 
  form: 'formEstimation',
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate: validate1
})(Stepper1);

function Stepper2(props){
 return <StepperData {...props}/>;
} 
Stepper2 = reduxForm({ 
  form: 'formEstimation',
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate: validate2
})(Stepper2);

function Stepper3(props){
 return <StepperData {...props}/>;
} 
Stepper3 = reduxForm({ 
  form: 'formEstimation',
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate: validate3
})(Stepper3);

export {Stepper1, Stepper2, Stepper3};